import React from 'react';

import Text from '/component/base/Text';
import reportsTestIDs from '/constant/TestIDs/Reports';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import testProperties from '/util/testing/testProperties';

interface CandidateDispositionProps {
  tt: (keyPrefix: any, value: any) => void;
  item: {
    dispositionDescription: any;
  };
}
export const CandidateDisposition = ({tt, item}: CandidateDispositionProps) => {
  const candidateDisposition = item?.dispositionDescription ?? '';
  return (
    <Text
      allowFontScaling
      maxFontSizeMultiplier={2}
      {...testProperties(reportsTestIDs.reportCandidateDisposition)}>
      {tt(
        'candidateDisposition',
        generateComponentCallback({
          component: <>{candidateDisposition}</>,
        }),
      )}
    </Text>
  );
};
export default withTranslation('report.record.CandidateDisposition')(
  CandidateDisposition,
);
